// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"42d2b5130af9161ae6ef","114":"9e51af4ef13c9a402ec0","115":"edac77303f949141adb7","163":"29ffdcdf26b970b51166"}[chunkId] + ".chunk.js";
};